import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 1,
  class: "wxlogin"
}
const _hoisted_3 = { class: "code-box" }
const _hoisted_4 = { class: "image-slot" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "info-bar" }
const _hoisted_7 = {
  key: 2,
  class: "phone-login"
}
const _hoisted_8 = { class: "phone-input" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "phone-input" }
const _hoisted_11 = { class: "info-bar" }

import { ref, onMounted, onUnmounted, watch, computed, reactive } from "vue";

import {
  loginWay,
  loginWayType,
  showLoginDialog,
  loginCodeUrl,
  validCode,
  verifyTime,
  closeLoginDialog,
  stopLoginPoll,
  getLoginCode,
  getVerifyCode,
  phoneLogin,
  getVerifyCodeAgain,
  openPrivacy,
  openAgreement,
} from "@/components/Dialogues/useData/login";
import { isCompactMode } from "@/data/pubilc";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginDialogue',
  setup(__props) {

const form = reactive({
  phoneNumber: "",
  code: "",
});

// const submit = (params: any) => {
//   getVerifyCodeAgain(form.phoneNumber, params);
// };
//手机模式，只有验证码登陆
const _loginWayType = ref(isCompactMode.value ? "手机号登录" : "扫码登录");

const dialogueDidClose = (done) => {
  closeLoginDialog();

  form.phoneNumber = "";
  form.code = "";
  _loginWayType.value = isCompactMode.value ? "手机号登录" : "扫码登录";

  done();
};

const ops = loginWay.map((item) => {
  return item.name;
});

watch(_loginWayType, (val) => {
  const value = _loginWayType.value;
  if (!showLoginDialog.value) {
    return;
  }
  if (value === "扫码登录") {
    loginWayType.value = 0;
    getLoginCode();
    console.log("发送二维码");
  } else {
    loginWayType.value = 1;
    stopLoginPoll();
    console.log("停止轮询");
  }
});

watch(loginWayType, (val) => {
  if (loginWayType.value == 1) {
    // stopLoginPoll();
    console.log("stopLoginPoll");
  } else {
    // getLoginCode();
    console.log("getLoginCode");
  }
});

const displayTitle = computed(() => {
  return verifyTime.value > 0 ? `重新获取(${verifyTime.value}s)` : "发送验证码";
});

const isRunning = computed(() => {
  return verifyTime.value > 0;
});

return (_ctx: any,_cache: any) => {
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showLoginDialog),
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(showLoginDialog) ? (showLoginDialog).value = $event : null)),
    width: "400",
    class: "custom",
    "align-center": "",
    center: "",
    "destroy-on-close": true,
    "before-close": dialogueDidClose,
    style: { '--el-border-radius-base': '16px' }
  }, {
    header: _withCtx(() => _cache[11] || (_cache[11] = [])),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_unref(isCompactMode))
          ? (_openBlock(), _createBlock(_component_el_segmented, {
              key: 0,
              style: {
          '--el-border-radius-base': '4px',
          '--el-segmented-item-selected-bg-color': '#4d6bfe',
        },
              modelValue: _loginWayType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_loginWayType).value = $event)),
              options: _unref(ops),
              size: "default"
            }, null, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true),
        (_loginWayType.value == '扫码登录')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_image, {
                  style: {"width":"100%","height":"100%"},
                  src: _unref(loginCodeUrl),
                  fit: `cover`
                }, {
                  error: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon_picture)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["src"]),
                (!_unref(validCode))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "err-cover",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(getLoginCode) && _unref(getLoginCode)(...args)))
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "reload-bar" }, [
                        _createTextVNode(" 二维码已失效 "),
                        _createElementVNode("div", { class: "btn" }, "重新获取")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title" }, "微信扫一扫更方便", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[13] || (_cache[13] = _createTextVNode(" 扫码登录表示您已同意 ")),
                  _createElementVNode("div", {
                    class: "link-btn",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(openAgreement) && _unref(openAgreement)(...args)))
                  }, "《服务协议》"),
                  _cache[14] || (_cache[14] = _createTextVNode(" 及 ")),
                  _createElementVNode("div", {
                    class: "link-btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(openPrivacy) && _unref(openPrivacy)(...args)))
                  }, "《隐私协议》")
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  maxlength: "11",
                  placeholder: "请输入手机号",
                  class: "input",
                  type: "text",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.phoneNumber) = $event))
                }, null, 512), [
                  [_vModelText, form.phoneNumber]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["code-btn", {
              disable: isRunning.value,
            }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(getVerifyCode)(form.phoneNumber, 'login')))
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(displayTitle.value), 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "请输入验证码",
                  type: "text",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.code) = $event))
                }, null, 512), [
                  [_vModelText, form.code]
                ])
              ]),
              _createElementVNode("div", {
                class: "primay-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(phoneLogin)(form)))
              }, "登录"),
              _createElementVNode("div", _hoisted_11, [
                _cache[16] || (_cache[16] = _createTextVNode(" 注册/登录表示您已同意 ")),
                _createElementVNode("div", {
                  class: "link-btn",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(openAgreement) && _unref(openAgreement)(...args)))
                }, "《服务协议》"),
                _cache[17] || (_cache[17] = _createTextVNode(" 及 ")),
                _createElementVNode("div", {
                  class: "link-btn",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(openPrivacy) && _unref(openPrivacy)(...args)))
                }, "《隐私协议》")
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})